import { useRef } from "react";
import "./Formato.css";
import CanvasDraw from "react-canvas-draw";
import useScreenSize from "../hooks/useScreenSize";
import { useForm } from "react-hook-form";
import axios from "axios";
import Ingreso from "../Ingreso/Ingreso";

const Formato = (props) => {
    const { register, handleSubmit, formState: { errors } } = useForm();

    const dibujo = useRef(null)
    const {width, heigth } = useScreenSize()

    const clear = () => {
        dibujo.current.clear()
    }

    const undo = () => {
        dibujo.current.undo()
    }

    function table_head(title){
        return(
            <tr className="formato_def">
                <td>{title}</td>
                <td className="formato_varios">C</td>
                <td className="formato_varios">NC</td>
                <td className="formato_varios">OBSERVACIONES</td>
            </tr>
        )
    }

    function item(denom,name,name_observaciones,obsevacion) {
        return(
            <tr>
                <td>{denom}</td>
                <td><input type="radio" name={name} {...register(""+name, {required: true})} value="CUMPLE" className="formato_checks" required/></td>
                <td><input type="radio" name={name} {...register(""+name, {required: true})}  value="NO CUMPLE" className="formato_checks"/></td>
                <td className="formato_observaciones"><input type="text" name={name_observaciones} {...register(""+name_observaciones, {required: false})} value={obsevacion} /></td>
            </tr>
        )
    }

    const onSubmit = data => {
        data['formato_dibujo']=dibujo.current.getSaveData()
        data['num_interno']=props.formatoData.codigo
        data['placa_vehic']=props.formatoData.placa
        data['marca_vehic']=props.formatoData.marca
        data['modelo_vehic']=props.formatoData.modelo
        data['user_sesion']=localStorage.getItem("login")
        axios.post("https://cootransfusa.com/mantenimiento-cootransfusa/", data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            props.handleDataReceived(response.data)
        })
        .catch(error => {
            console.error(error);
        });
    };

    const regreso = () => {
        const data = {
            sesion: true,
            ingreso: true
        }
        props.handleDataReceived(props.stringify(data))
    }

    return(
        <div className="formato">
            <button type="button" onClick={regreso} className='button_back'><i class="fa-solid fa-rotate-left" style={{ color: "#ffffff", marginRight: "10px" }}></i>Regresar</button>
            <h1 className="formato_h1">Inspección preoperacional de Vehículos Livianos</h1>
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formato_info">
                    <span> Número Interno: {props.formatoData.codigo}</span>
                    <span> Placa: {props.formatoData.placa}</span>
                    <span> Marca: {props.formatoData.marca}</span>
                    <span> Modelo: {props.formatoData.modelo}</span>
                </div>

                <br />

                <div className="formato_diligenciar">
                    <table>
                        <tr>
                            <td>KILOMETRAJE</td>
                            <td colSpan="3"><input type="number" name="kilometraje" {...register("kilometraje",{required: true})} required/></td>
                        </tr>
                        <tr className="formato_def">
                            <td>DOCUMENTOS LEGALES</td>
                            <td colSpan="2">Vencimiento</td>
                            <td className="formato_varios">OBSERVACIONES</td>
                        </tr>
                        <tr>
                            <td>Tarjeta de Propiedad</td>
                            <td colSpan="2"><input type="date" name="vencim_propiedad" {...register("vencim_propiedad",{required: true})} required/></td>
                            <td><input type="text" name="vencim_propiedad_obs" {...register("vencim_propiedad_obs",{required: false})}/></td>
                        </tr>
                        <tr>
                            <td>Tarjeta de Operación (Servicio Público)</td>
                            <td colSpan="2"><input type="date" name="vencim_operacion" {...register("vencim_operacion",{required: true})} required/></td>
                            <td><input type="text" name="vencim_operacion_obs" {...register("vencim_operacion_obs",{required: false})}/></td>
                        </tr>
                        <tr>
                            <td>Seguro obligatorio</td>
                            <td colSpan="2"><input type="date" name="vencim_seguro" {...register("vencim_seguro",{required: true})} required/></td>
                            <td><input type="text" name="vencim_seguro_obs" {...register("vencim_seguro_obs",{required: false})}/></td>
                        </tr>
                        <tr>
                            <td>Revisión Tecnico Mecánica y Análisis de Gases</td>
                            <td colSpan="2"><input type="date" name="vencim_tecno" {...register("vencim_tecno",{required: true})} required/></td>
                            <td><input type="text" name="vencim_tecno_obs" {...register("vencim_tecno_obs",{required: false})}/></td>
                        </tr>
                        <tr>
                            <td>Seguro Extracontractual</td>
                            <td colSpan="2"><input type="date" name="vencim_extracontractual" {...register("vencim_extracontractual",{required: true})} required/></td>
                            <td><input type="text" name="vencim_extracontractual_obs" {...register("vencim_extracontractual_obs",{required: false})}/></td>
                        </tr>
                        {table_head("CONDICIONES NORMALES")}
                        {item("Nivel Aceite del Motor","formato_aceite_motor","formato_aceite_motor_obs")}
                        {item("Nivel Aceite de la Transmisión","formato_aceite_transmision","formato_aceite_transmision_obs")}
                        {item("Nivel Aceite del Hidráulico","formato_aceite_hidraulico","formato_aceite_hidraulico_obs")}
                        {item("Líquido del Embrague","formato_liquido_embrague","formato_liquido_embrague_obs")}
                        {item("Nivel Líquido de Frenos","formato_liquido_frenos","formato_liquido_frenos_obs")}
                        {item("Nivel Agua del Radiador","formato_agua_radiador","formato_agua_radiador_obs")}
                        {item("Nivel Agua de la Batería","formato_agua_bateria","formato_agua_bateria_obs")}
                        {item("Nivel Agua del Limpiabrisas","formato_agua_limpiabrisas","formato_agua_limpiabrisas_obs")}
                        {item("Fuga Aceite Motor","formato_fuga_aceite_motor","formato_fuga_aceite_motor_obs")}
                        {item("Fuga Líquido de Frenos","formato_fuga_liquido_frenos","formato_fuga_liquido_frenos_obs")}
                        {item("Fuga Líquido de Embrague","formato_fuga_liquido_embrague","formato_fuga_liquido_embrague_obs")}
                        {item("Fuga Aceite de Transmisión","formato_fuga_aceite_transmision","formato_fuga_aceite_transmision_obs")}
                        {item("Fuga Agua del Radiador","formato_fuga_agua_radiador","formato_fuga_agua_radiador_obs")}
                        {item("Fuga en Exosto / Gases","formato_fuga_exosto","formato_fuga_exosto_obs")}
                        {item("Estado y Sujeción de las Mangueras","formato_estado_mangueras","formato_estado_mangueras_obs")}
                        {item("Estado y Tensión de las correas","formato_estado_correas","formato_estado_correas_obs")}
                        {item("Estado y Sujeción de la Batería (Bornes y Cables)","formato_estado_bateria","formato_estado_bateria_obs")}
                        {item("Freno de Emergencia","formato_freno_emergencia","formato_freno_emergencia_obs")}
                        {item("Estado de la Suspensión","formato_estado_suspension","formato_estado_suspension_obs")}

                        {table_head("PARTE EXTERNA")}
                        {item("Estado General de Latonería y Pintura","formato_estado_latoneria","formato_estado_latoneria_obs")}
                        {item("Puertas en Buen Estado (Cierre y Bloqueo)","formato_estado_puertas","formato_estado_puertas_obs")}
                        {item("Manija Puertas y Vidrios","formato_manija","formato_manija_obs")}
                        {item("Espejo Retrovisores Laterales y Central","formato_espejo_retrovisores","formato_espejo_retrovisores_obs")}
                        {item("Vidrios de Ventanas y Panorámico","formato_vidrios_panoramico","formato_vidrios_panoramico_obs")}
                        {item("Placa","formato_placa","formato_placa_obs")}
                        {item("Limpiabrisas","formato_limpiabrisas","formato_limpiabrisas_obs")}
                        {item("Tapa Tanque de Combustible","formato_tapa_tanque","formato_tapa_tanque_obs")}
                        {item("Estribos","formato_estribos","formato_estribos_obs")}

                        {table_head("PARTE INTERNA")}
                        {item("Cinturon de Seguridad en Todos los Asientos","formato_cinturon","formato_cinturon_obs")}
                        {item("Airbag","formato_airbag","formato_airbag_obs")}
                        {item("Pedales y Mandos","formato_pedales_mandos","formato_pedales_mandos_obs")}
                        {item("Indicadores de Tablero","formato_indicadores_tablero","formato_indicadores_tablero_obs")}
                        {item("Estado de Tapicería","formato_estado_tapiceria","formato_estado_tapiceria_obs")}
                        {item("Luces de Techo y Tableros","formato_techo_tableros","formato_techo_tableros_obs")}
                        {item("Parasoles Sujeción y Estado","formato_parasoles","formato_parasoles_obs")}
                        {item("Aire Acondicionado","formato_aire_acondicionado","formato_aire_acondicionado_obs")}
                        {item("Asientos / Apoya Cabeza / Espaldar","formato_asientos","formato_asientos_obs")}
                        {item("Pito Normal","formato_pito","formato_pito_obs")}
                        {item("Monitor de Velocidad","formato_monitor_velocidad","formato_monitor_velocidad_obs")}

                        {table_head("LUCES")}
                        {item("Frontales","formato_frontales","formato_frontales_obs")}
                        {item("Direccionales Delanteras y de Parqueo","formato_direccionales_delanteras","formato_direccionales_delanteras_obs")}
                        {item("Direccionales Traseras y de Parqueo","formato_direccionales_traseras","formato_direccionales_traseras_obs")}
                        {item("De Stop y Señal Trasera","formato_stop","formato_stop_obs")}
                        {item("Luz y Alarma de Reversa","formato_alarma_reversa","formato_alarma_reversa_obs")}

                        {table_head("LLANTAS")}
                        {item("Llantas Delanteras (Con Más de 5mm de Labrado)","formato_llantas_delanteras","formato_llantas_delanteras_obs")}
                        {item("Llantas Traseras (Con Más de 5mm de Labrado)","formato_llantas_traseras","formato_llantas_traseras_obs")}
                        {item("Llanta de Repuesto Inflada y en Buen Estado (Con Más de 5mm de Labrado)","formato_llanta_repuesto","formato_llanta_repuesto_obs")}
                        {item("Rines, Pernos Completos y Ajustados","formato_rines_pernos","formato_rines_pernos_obs")}
                        {item("Presión de Aire de las Llantas","formato_presion_llantas","formato_presion_llantas_obs")}

                        {table_head("EQUIPO DE PREVENCIÓN")}
                        {item("Extintor (Tipo 10 BC)","formato_extintor","formato_extintor_obs")}
                        {item("Botiquín de Primeros Auxilios","formato_botiquin","formato_botiquin_obs")}
                        {item("Cajón para herramientas con Mínimo Alicate, Destornilladores, llave de Expansión y Llaves Fijas","formato_cajon_herramientas","formato_cajon_herramientas_obs")}
                        {item("Conos Reflectivo y Tacos Compactos","formato_conos_tacos","formato_conos_tacos_obs")}
                        {item("Gato Elevador y Copa Para Pernos","formato_gato_copa","formato_gato_copa_obs")}
                        {item("Linterna en Funcionamiento","formato_linterna","formato_linterna_obs")}
                        {item("Inmovilizadores","formato_inmovilizadores","formato_inmovilizadores_obs")}
                        {item("Chaleco Reflectivo","formato_chaleco","formato_chaleco_obs")}

                        <tr className="formato_def">
                            <td colSpan="4">ESTADO DE LATONERÍA</td>
                        </tr>

                        <tr>
                            <td colspan="4">Indique con una "X" el lugar donde el vehículo presente golpes o rayones</td>
                        </tr>
                    </table>

                    <div className="formato_canvas">                        
                        <CanvasDraw 
                            ref={dibujo}
                            brushRadius={1} 
                            brushColor="red" 
                            catenaryColor="red"
                            canvasWidth={width<=924 ? 640:924}
                            canvasHeight={476}
                            //imgSrc="./img/dibujo-buseta.jpg"
                            imgSrc="./img/dibujo-buseta.jpg"
                        />
                    </div>

                    <div className="formato_botones_borrar">
                        <button type="button" onClick={clear} className="formato_button_limpiar">Limpiar</button>
                        <button type="button" onClick={undo} className="formato_button_borrar">Borrar</button>
                    </div>
                            
                    <br />
                    <table>
                        <tr className="formato_def">
                            <td colspan="4"><b>Observaciones</b></td>
                        </tr>
                        <tr>
                            <td colSpan={4}><textarea name="formato_observaciones" {...register("formato_observaciones",{required: true})} id="" cols="100" rows="10" className="formato_observaciones" required></textarea></td>
                        </tr>
                        <tr>
                            <td colspan="4">Por la firma del presente formato, el conductor se hace responsable del cumplimiento de la política de seguridad vial de PRE, de normas de seguridad industrial que se describen en nuestras políticas y de las normas de transito. En consecuencia, será responsable por los daños o perdidas que sufra el vehiculo por violación de estas normas o derivados de su negligencia.      
                                            *Estos items inhabilitan el vehículo para operar.
                                            ** Si se presenta fuga de  cualquiera de los fluidos mencionados, el vehículo NO ES APTO para trabajar.                                                                                                                                                    *** Espacio a diligenciar para vehiculos que ingresen por primera vez al campo, cambio de usuario y mensualmente para vehiculos de la empresa.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" className="formato_def formato_campo_condctor">Nombre de Conductor</td>
                            <td colspan="2" className="formato_campo_condctor"><input type="text" name="formato_conductor" {...register("formato_conductor",{required: true})} required/></td>
                        </tr>
                    </table>
                </div>
                <br />
                <input type="submit" value="Registrar Inspección" className="formato_button_submit"/>
            </form>
        </div>
    )
}

export default Formato;